module.exports = __webpack_public_path__ + "static/assets/9432084226baf93e8b19ba4663dd1d98.gif";